import React, { useState } from "react";
import { Link } from "react-router-dom";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import CourseLeft from '../components/CourseLeft';
import CourseForm from "../components/CourseForm";
import CorseResult from "../components/CourseResult";
import CourseTestimonial from "../components/CourseTestimonial";
import Footer from '../components/Footer';
import courseicon1 from '../components/images/courseIcon2.png';
import courseicon2 from '../components/images/courseIcon3.png';
import courseicon3 from '../components/images/courseIcon4.png';
import courseicon4 from '../components/images/courseIcon5.png';
import courseicon5 from '../components/images/courseIcon6.png';
import courseicon6 from '../components/images/courseicon.png';
import owner from '../components/images/vigyanvriksh-csirnet.png';
import owner1 from '../components/images/vigyanvriksh-csirnet1.png';


import poster from '../components/images/vigyavriksh-poster.png';



function PatentOfficer (){
    
    return (
        <>
            <Headertop /> 
            <Navbar />
            
            <section className="hero-section d-flex align-items-center bg-red text-white">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left: Text */}
                        <div className="col-lg-8 mb-5 mb-lg-0">
                            <div className="text-left animate-text">
                                <h2 className="fw-bold mb-3">Prepare with India's Most <br /><span className="text-warning">Advanced Test Series</span></h2>
                                <p className="lead mb-4">Available with <span className="fw-bold text-warning">VIDEO AND TEXT SOLUT</span></p>
                                <div className="badge bg-white text-danger fs-5 p-2">
                                    <strong>JEE/NEET</strong> Session <strong>2025–26</strong>
                                </div>
                            </div>
                        </div>
                        {/* Right: Form */}
                        <div className="col-lg-4">
                           <CourseForm />
                        </div>
                    </div>
                </div>
            </section>

            <div className="container-fluid coursepagebox">
                <div className="row">
                    <h2>IIT JAM</h2>
                    <p>Vigyan Vriksh ensures to provide quality education for optimum results and success of students.</p>
                </div>

                <div className="row mt-5">
                    <div className="col-md-3">
                        <CourseLeft />
                    </div>

                    <div className="col-md-9">
                        <div className="rightbar">
                            <div className="tabs">
                                <button className="tab active" data-tab="tab1">Course Description</button>
                                <button className="tab" data-tab="tab2">Planner</button>
                                <button className="tab" data-tab="tab3">Fees Structure</button>
                                <button className="tab" data-tab="tab3">Teaching Methodologies</button>
                                <button className="tab" data-tab="tab3">Result & Testimonials</button>
                            </div>
                            <div className="mt-5 courseditails">
                                <h3>Course Description of CSIR NET</h3>
                                <p>Vigyan Vriksh has long been distinguished for providing the Best Coaching, Online Learning Facility and getting excellent results. The curriculum is specifically designed for the CSIR NET June 2025 aspirants. To strengthen the foundation, conceptual knowledge and enhance the academic skills this course is the best option. The course helps the aspirants with better understanding of the examination pattern and ensure their success in the CSIR NET with ease through a Session-long curriculum.</p>
                                <h3 className="mt-5">Course Highlights</h3>
                                <div className="row g-4">
                                    <div className="col-md-6 col-sm-6">
                                        <div className="highlight-card">
                                            <div className="highlight-box">
                                                <img src={courseicon1} alt="" width="40" />
                                            </div>
                                            <div>
                                                <div className="highlight-title">Structured Academic Planner for CSIR NET.</div>
                                                <div className="highlight-count">2 Courses</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="highlight-card">
                                            <div className="highlight-box">
                                                <img src={courseicon2} alt="" width="40" />
                                            </div>
                                            <div>
                                                <div className="highlight-title">Structured and Targeted Assignments and DPP</div>
                                                <div className="highlight-count">2 Courses</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="highlight-card">
                                            <div className="highlight-box">
                                                <img src={courseicon3} alt="" width="40" />
                                            </div>
                                            <div>
                                                <div className="highlight-title">Test Series On Regular Basis for Progress Tracking</div>
                                                <div className="highlight-count">1 Courses</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="highlight-card">
                                            <div className="highlight-box">
                                                <img src={courseicon4} alt="" width="40" />
                                            </div>
                                            <div>
                                                <div className="highlight-title">Doubt Session + Recorded lectures</div>
                                                <div className="highlight-count">1 Courses</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="highlight-card">
                                            <div className="highlight-box">
                                                <img src={courseicon5} alt="" width="40" />
                                            </div>
                                            <div>
                                                <div className="highlight-title">Interactive classes for better understanding</div>
                                                <div className="highlight-count">1 Courses</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="highlight-card">
                                            <div className="highlight-box">
                                                <img src={courseicon6} alt="" width="40" />
                                            </div>
                                            <div>
                                                <div className="highlight-title">Regular Mentorship Sessions with faculties</div>
                                                <div className="highlight-count">1 Courses</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section className="planner-section rigthmiddle text-white py-5 px-3 rounded-4">
                            <div className="container p-5">
                                <h2 className="text-center fw-bold mb-4">Planner</h2>
                                <div className="planner-item d-flex align-items-start gap-3 mb-4">
                                    <img src={courseicon1} className="icon-img" alt="icon1" />
                                    <p><span className="highlight">450+</span> Online &amp; Classes (Physical Chemistry 150+, Organic Chemistry 150+ & Inorganic Chemistry 150+) with Lecture of 90 Minute Each.</p>
                                </div>
                                <div className="planner-item d-flex align-items-start gap-3 mb-4">
                                    <img src={courseicon2} className="icon-img" alt="icon2" />
                                    <p><span className="highlight">6000+</span> Questions Practice accessible in both Online and Offline mode.</p>
                                </div>
                                <div className="planner-item d-flex align-items-start gap-3 mb-4">
                                    <img src={courseicon3} className="icon-img" alt="icon3" />
                                    <p><span className="highlight">45+</span> Test Papers Will Conduct for Practice.</p>
                                </div>
                                <div className="planner-item d-flex align-items-start gap-3 mb-5">
                                    <img src={courseicon4} className="icon-img" alt="icon4" />
                                    <p><span className="text-warning fw-semibold">Free Access of Learning App</span> which contain Live className &amp; Recorded Video Lectures, Video Solutions, PYQ'S &amp; Other Support.</p>
                                </div>
                                <div className="d-flex gap-3 justify-content-center">
                                    <Link to="/" className="btn btn-light text-danger fw-bold px-4 py-2">Enroll Now</Link>
                                    <Link to="/" className="btn btn-light text-danger fw-bold px-4 py-2 d-flex align-items-center gap-2"><i className="bi bi-download"></i> Planner</Link>
                                </div>
                            </div>
                        </section>

                        <div className="container my-5">
                            <h3 className="text-center fw-bold">Course Fee - Targeting CSIR NET</h3>
                            <p className="text-center text-muted">Available in classNameroom Mode</p>
                            <div className="position-relative bg-white p-4 mt-4 pt-5 fee-card">
                                <div className="fee-badge">Online Program</div>
                                <p className="text-center mt-5 fw-bold">
                                    <span className="text-uppercase text-danger">SUPER 100 Program</span><br/>Online Mode is available for student who wants to study LIVE
                                </p>
                                <div className="table-responsive mt-4 custom-table">
                                    <table className="table text-center mb-0">
                                        <thead>
                                            <tr>
                                                <th>Batch Fee</th>
                                                <th>Booklet Fee</th>
                                                <th>Total Fee</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>₹ 9,000</td>
                                                <td>₹ 2,500</td>
                                                <td>₹ 11,500</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-center mt-4"><button className="btn btn-pay">Pay Now</button></div>
                                <div className="mt-4 note-text">
                                    <p>* EMI option available with 0% interest rate.</p>
                                    <p>* Fee of ₹ 11500/- is non-refundable.</p>
                                </div>
                            </div>
                        </div>

                        <div className="container my-5">
                            <div className="position-relative bg-white p-4 mt-4 pt-5 fee-card">
                                <h3 className="text-center">Upcoming Batch Dates &nbsp;&nbsp;&nbsp; <button className="btn btn-pay">Pay Now</button></h3>
                            </div>
                        </div>

                        <div className="container my-5">    
                            <div className="classroom-card">
                                <div className="hero-box mb-4">
                                    <h3 className="text-white">BEST CLASSROOM PROGRAM FOR <br /><span>CSIR NET PREPARATION</span></h3>
                                    <img src={owner} alt="Teacher" className="hero-img" />
                                </div>
                                <div className="feature-item d-flex">
                                    <div>
                                        <div className="feature-title"><p><i className="bi bi-laptop"></i> Regular Sessionlong LIVE Program</p></div>
                                        <div className="progdiscription"><p>Our Super 100 programs are very interactive and are designed with such proficiency that no extra study material is needed to achieve your desired success in CSIR NET.</p></div>
                                    </div>
                                </div>
                                <div className="feature-item d-flex">
                                    <div>
                                        <div className="feature-title"><p><i className="bi bi-journal-text"></i> Topic wise DPP's and Question Bank</p></div>
                                        <div className="progdiscription"><p>Focuses on boosting confidence of students for facing National Level competitive exams by providing subject wise and topic wise questions with solutions.</p></div>
                                    </div>
                                </div>
                                <div className="feature-item d-flex">
                                    <div>
                                        <div className="feature-title"><p><i className="bi bi-award-fill"></i> Test Your Performance With Vigyan Vriksh Test Series</p></div>
                                        <div className="progdiscription"><p>Online Test Series (OTS) is designed according to CSIR NET exam pattern that stimulates the actual examination environment and provides an opportunity to revise every concept thoroughly.</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container my-5">
                            <div className="classroom-card">
                                <div className="hero-box mb-4">
                                    <h3>CSIR NET Online Study with <br /><span>VIGYAN VRIKSH LEARNING APP</span></h3>
                                    <img src={owner1} alt="Teacher" className="hero-img" />
                                </div>
                                <div className="feature-item d-flex">
                                    <div className="feature-icon"><i className="bi bi-laptop"></i></div>
                                    <div>
                                        <div className="feature-title"><p>Access to Video Lectures</p></div>
                                        <div><p>Attend Live Classes. Study online anytime, anywhere with the best quality recorded Video Lectures designed by top Vigyan Vriksh faculties. Revisit important topics whenever you need.</p></div>
                                    </div>
                                </div>
                                <div className="feature-item d-flex">
                                    <div className="feature-icon"><i className="bi bi-journal-text"></i></div>
                                    <div>
                                        <div className="feature-title"><p>Instant Doubt Resolution</p></div>
                                        <div><p>Get all your doubts answered instantly during and after classes. Your doubts will be answered shortly by Top Educators. You can also clear doubts through Live Chat feature.</p></div>
                                    </div>
                                </div>
                                <div className="feature-item d-flex">
                                    <div className="feature-icon"><i className="bi bi-award-fill"></i></div>
                                    <div>
                                        <div className="feature-title"><p>Performance Statistics</p></div>
                                        <div><p>Analyze your performance in mock test conducted regularly based on NTA pattern. The app allow learners to take chapter-wise quizzes to evaluate their performance and identify their strong and weak topics.</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <CorseResult />

                        <div className="mt-5 mb-5">
                            <img src={poster} className="" alt="User" style={{ width: "100%" }} />
                        </div>
                        <CourseTestimonial />
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
export default PatentOfficer;